import type { FaireProductEntity } from "../../entity_types/product";

export const p_ddvedavc38: FaireProductEntity = {
  token: "p_ddvedavc38",
  type: "product",
  name: "Dulce de Cuerpo, 10mL Perfume Travel Spray",
  brandToken: "b_c3hepkjc1t",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.faire.com/fastly/ec5590bf26aef9bd9b202733cc1df102643ef3f59f9c2b0f4f6be3f0ff8a320b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/28d1b57f726d37aea49db42de9bd0aef0be3cfb97f70b000ca2de93b768a5533.jpeg",
    "https://cdn.faire.com/fastly/80945029e59b051ef4e597f4ca24f5709058c89fa986e209023da8ecee873841.jpeg",
    "https://cdn.faire.com/fastly/6c75fb83fa9f2cbc06b3ef8a1abf3c99d2cceac031f462a93d10914e5a270f8e.jpeg",
    "https://cdn.faire.com/fastly/bae29b5d6523ef3da2c2e4435e26b07e35e7d7ad971083c1e1936b1829af939f.jpeg",
    "https://cdn.faire.com/fastly/6a162e435af45926d369955c03e08ebfb044a2dd935381e929dc04e33334914c.jpeg",
  ],
  priceDollars: 15,
  description:
    "\n10mL spritzer, travel spray\n\nPowerfully smoky and enduring, Dulce de Cuerpo eau de parfum captures the essence of Mexico City and its enchanting Pueblos Mágicos. Sweet earth blends with violet and amber, while copal, vanilla, and sandalwood envelop you in warmth. Perfect as your signature scent, from dawn to dusk and beyond. Gender neutral scent.\n\nTOP: Sweet Earth \nMID: Incense, Amber, Violet\nBASE: Copal, Vanilla, Sandalwood\n\nClean formulation with no phthalates, parabens or sulfates\nVegan | Cruelty free | Gluten free\n\nInstructions for use: Spray on pulse points, where  skin is naturally warmer. These areas include the wrists, behind the ears, the inner elbows. The warmth will help to release the fragrance throughout the day. Keep your perfume in a cool, dry place away from direct sunlight and heat to preserve its integrity and longevity.\n\n\nWe are a clean brand. Our products are vegan and free from hormone disruptors and phthalates.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:21:07.660Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
